<template>
  <van-tabbar v-if="show" v-model="active" active-color="#f3c7a2" inactive-color="#979799" :border="false">
    <van-tabbar-item
      v-for="item in items"
      :key="item.key"
      :class="{ 'footer-vote-entry': item.key === 'vote' }"
      @click="navigate(item)"
    >
      <span class="footer-item-label">{{ item.title }}</span>
      <template #icon="props">
        <svg v-if="item.key === 'vote'" class="footer-vote-heart" viewBox="0 0 16 16" aria-hidden="true">
          <defs>
            <linearGradient id="footer-vote-heart-red" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#ff6672" />
              <stop offset="1" stop-color="#c91835" />
            </linearGradient>
          </defs>
          <path fill="url(#footer-vote-heart-red)" fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314" />
        </svg>
        <img v-else :src="props.active ? item.activeIcon : item.icon" :alt="item.key">
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import homeIcon from '@/assets/img/vida-home/zy.png'
import homeActiveIcon from '@/assets/img/vida-home/zy1.png'
import feedbackIcon from '@/assets/img/vida-home/yh.png'
import feedbackActiveIcon from '@/assets/img/vida-home/yh1.png'
import voteIcon from '@/assets/img/vida-home/dt.png'
import voteActiveIcon from '@/assets/img/vida-home/dt1.png'
import cinemaIcon from '@/assets/img/vida-home/video.png'
import cinemaActiveIcon from '@/assets/img/vida-home/video1.png'
import mineIcon from '@/assets/img/vida-home/wd.png'
import mineActiveIcon from '@/assets/img/vida-home/wd1.png'

export default {
  data() {
    return {
      show: false,
      active: 0,
      loadingTask: false,
      itemConfig: [
        { key: 'home', titleKey: 'home', route: '/Home', icon: homeIcon, activeIcon: homeActiveIcon },
        { key: 'feedback', titleKey: 'feedback', route: '/Choose', icon: feedbackIcon, activeIcon: feedbackActiveIcon },
        { key: 'vote', titleKey: 'vote', route: '/Lottery', taskEntry: true, icon: voteIcon, activeIcon: voteActiveIcon },
        { key: 'cinema', titleKey: 'cinema', route: '/Video', icon: cinemaIcon, activeIcon: cinemaActiveIcon },
        { key: 'mine', titleKey: 'mine', route: '/Mine', icon: mineIcon, activeIcon: mineActiveIcon }
      ]
    }
  },
  computed: {
    items() {
      return this.itemConfig.map(item => ({ ...item, title: this.$t(`appUi.${item.titleKey}`) }))
    }
  },
  methods: {
    navigate(item) {
      if (item.taskEntry) { this.openFirstTask(); return }
      if (item.key === 'mine') this.$emit('credit-alert-request')
      if (this.$route.path.toLowerCase() !== item.route.toLowerCase()) this.$router.replace(item.route)
    },
    async openFirstTask() {
      if (this.loadingTask) return
      if (!localStorage.getItem('token')) { this.$router.push('/Login'); return }
      this.loadingTask = true
      try {
        let response = await this.$http({ method: 'get', url: 'lottery_hot' })
        let tasks = Array.isArray(response.data) ? response.data : []
        if (!tasks.length) {
          response = await this.$http({ method: 'get', url: 'lottery_list' })
          tasks = Array.isArray(response.data) ? response.data : []
        }
        const task = tasks.find(entry => entry && entry.id && entry.key)
        if (!task) { this.$toast(this.$t('common.nodata')); return }
        this.$router.push({ path: '/Lottery', query: { key: task.key, id: task.id } })
      } catch (error) {
        this.$toast(this.$t('common.networkError'))
      } finally {
        this.loadingTask = false
      }
    },
    syncRoute(route) {
      const routeName = route && route.name
      const routePath = route && route.path ? route.path.toLowerCase() : ''
      if (routeName === 'home') this.active = 0
      else if (routeName === 'choose' || routePath === '/choose' || routeName === 'pl' || routePath === '/pl') this.active = 1
      else if (routeName === 'video') this.active = 3
      else if (routeName === 'mine') this.active = 4
      else { this.show = false; return }
      this.show = true
    }
  },
  watch: { $route(to) { this.syncRoute(to) } },
  created() { this.syncRoute(this.$route) }
}
</script>

<style lang="less" scoped>
.van-tabbar {
  left: 50%;
  width: 100%;
  height: calc(clamp(52px, 14.667vw, 64px) + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  transform: translateX(-50%);
  background: #1f1c1f;
  overflow: visible;
}
.van-tabbar-item { min-width: 0; padding: 0; background: transparent; font-size: clamp(12px, 3.467vw, 15px); }
.van-tabbar-item__icon img { width: auto; height: clamp(24px, 7vw, 30px); }
.van-tabbar-item span { display: block; line-height: 1; white-space: nowrap; }
.van-tabbar-item--active { background: transparent; }
.footer-vote-entry { position: relative; z-index: 2; overflow: visible; }
.footer-vote-entry::before {
  position: absolute;
  top: clamp(-17px, -4vw, -13px);
  left: 50%;
  width: clamp(58px, 16.8vw, 66px);
  height: clamp(58px, 16.8vw, 66px);
  border: 2px solid #e7c67b;
  border-radius: 50%;
  background: linear-gradient(145deg, #302a2b 0%, #181719 72%);
  box-shadow: 0 -4px 14px rgba(232, 199, 125, .2), 0 7px 16px rgba(0, 0, 0, .4), inset 0 0 0 3px rgba(255, 255, 255, .025);
  content: '';
  transform: translateX(-50%);
}
.footer-vote-entry .van-tabbar-item__icon {
  position: relative;
  z-index: 1;
  margin-top: -13px;
  margin-bottom: 4px;
}
.footer-vote-heart {
  display: block;
  width: auto;
  height: clamp(30px, 8.5vw, 34px);
  filter: drop-shadow(0 2px 4px rgba(120, 8, 26, .4));
}
.footer-vote-entry .footer-item-label {
  position: relative;
  z-index: 1;
  color: #f2cd82;
  font-size: clamp(12px, 3.467vw, 14px);
  font-weight: 700;
}
[class*='van-hairline']::after { border: none !important; }
@media screen and (min-width: 1024px) {
  .van-tabbar { width: 430px; height: calc(50px + env(safe-area-inset-bottom)); }
  .van-tabbar-item { font-size: 18px; }
  .van-tabbar-item__icon img { height: 20px; }
}
</style>
